import { __assign } from "tslib";
/**
 * Function that converts PageRange and ClearRange to a common Range object.
 * PageRange and ClearRange have start and end while Range offset and count
 * this function normalizes to Range.
 * @param response Model PageBlob Range response
 */
export function rangeResponseFromModel(response) {
    var pageRange = (response._response.parsedBody.pageRange || []).map(function (x) { return ({
        offset: x.start,
        count: x.end - x.start
    }); });
    var clearRange = (response._response.parsedBody.clearRange || []).map(function (x) { return ({
        offset: x.start,
        count: x.end - x.start
    }); });
    return __assign(__assign({}, response), { pageRange: pageRange,
        clearRange: clearRange, _response: __assign(__assign({}, response._response), { parsedBody: {
                pageRange: pageRange,
                clearRange: clearRange
            } }) });
}
//# sourceMappingURL=PageBlobRangeResponse.js.map